import "../App.scss";
import { useSelector } from "react-redux";
import { selectImages, selectSpEnvironment } from "state/selectors/Selectors";
import Breadcrumbs from "components/breadcrumbs/Breadcrumbs";
import FrequentlyVisitedLinks from "components/FrequentlyVisitedLinks";
import BannerImageCarousel from "components/BannerImageCarousel";
import PermissionsBanner from "components/PermissionsBanner";
import { getImageBySection } from "utils/utils";
import { IMAGESECTIONS } from "InterfacesTypes/enums";
import ResourceLinksList from "components/resourceLinksList/ResourceLinksList";
import Navigation from "components/navigation/Navigation";
import Footer from "components/footer/Footer";
import HeroImagesSection from "components/imagesSection/HeroImagesSection";
import QuickLinks from "components/QuickLinks";
import NotificationModal from "components/NotificationModal";
import NotificationBanner from "components/NotificationBanner";

const Home = () => {
    const heroImages = useSelector(selectImages);
    const spEnv = useSelector(selectSpEnvironment);
    const topImageObject = getImageBySection(heroImages, IMAGESECTIONS.TOP_IMAGE);

    return (
        <>
            {spEnv === "logistikportalen" &&
                <NotificationModal />
            }
            <div className="app-container text-base">
                <BannerImageCarousel />
                <div className="bg-[rgba(33,37,41,1)] flex items-center justify-cente">
                    <Navigation />
                </div>
                <div className="!pl-2 !mt-2">
                    <Breadcrumbs
                        page="Start"
                    />
                </div>
                <NotificationBanner />
                {spEnv !== "logistikportalen" &&
                    <div className="flex gap-[1px] [@media(min-width:390px)]:!mx-8 flex-col lg:flex-row!">
                        <div className="flex flex-col gap-[0.05rem] basis-[75%] !mx-2">
                            <div className="ml-2">
                                <PermissionsBanner topImageObject={topImageObject} />
                            </div>
                            <div className="ml-2">
                                <HeroImagesSection imageItems={heroImages} />
                            </div>
                        </div>
                        <div className="basis-[25%] !mr-2 !ml-2 [@media(min-width:390px)]:!ml-0">
                            <FrequentlyVisitedLinks />
                        </div>
                    </div>
                }
                <ResourceLinksList />
                <QuickLinks />
                {spEnv !== "logistikportalen" &&
                    <Footer />
                }
            </div>
        </>
    );
};

export default Home;
